import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_FRONT_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Rediriger vers la page de connexion si le token est invalide
      localStorage.removeItem('access_token');
      localStorage.removeItem('spotify_access');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
